import Http from '../http';

export const getAutoCompleteSearch = async (querySearch) => {
  try {
    const response = await Http.get(`${process.env.BFFV2_BASE_URL}/common/autocomplete?searchTerm=${querySearch || ''}`);
    if (response?.status !== 200) {
      throw new Error("Can't get the auto complete list");
    }
    return response?.data;
  } catch (e) {
    console.error('something went wrong', e);
    return false;
  }
};

export default {
  getAutoCompleteSearch,
};
